var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrCode"},[_c('div',{staticClass:"tit",domProps:{"textContent":_vm._s(_vm.QRtitle)}}),_c('img',{attrs:{"src":_vm.QRUrl,"alt":"","width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }